exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* For Chrome, Safari, Edge, Opera */\ninput.textfield::-webkit-outer-spin-button,\ninput.textfield::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* For Firefox */\ninput.textfield {\n  -moz-appearance: textfield;\n}\n\n", ""]);

// exports
